import { postAPI } from '../utils/ApiFunctions';

class FulfillmentService {
    async postFulfillment(estimateInfo, correlationId) {
        return new Promise((resolve, reject) => {
            try {
                postAPI(process.env.FULFILLMENT_URL, estimateInfo, correlationId)
                    .then((resp) => {
                        if (resp instanceof Error) {
                            reject(resp);
                        }
                        resolve(resp.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            } catch (error) {
                console.error(error);
                reject(error);
            }
        });
    }
}

export default new FulfillmentService();
